import actionTypes from '../constants/action-types';

const setBuildSlug = (templateBuildSlug) => ({
  type: actionTypes.SET_TEMPLATE_BUILD_SLUG,
  payload: {
    templateBuildSlug,
  },
});

export default setBuildSlug;
